import React, { useState, useEffect, useRef, useCallback } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

import { useOnClickOutside } from 'hooks/outsideClick.hook';
import { useScrollBlock } from 'hooks/useScrollBlock';
import { MODAL_ID } from 'constants/settings';

import './modalWindow.scss';

function ModalWindow(props) {
  const [open, setOpen] = useState(false);
  const [blockScroll, allowScroll] = useScrollBlock();
  const ref = useRef();

  const handleClose = useCallback(() => {
    setOpen(false);
    allowScroll();
    props.closeCallback && props.closeCallback();
  }, [props, allowScroll]);

  useEffect(() => {
    const handleEsc = (event) => {
      if (event.keyCode === 27) {
        handleClose();
      }
    };
    window.addEventListener('keydown', handleEsc);

    return () => {
      window.removeEventListener('keydown', handleEsc);
    };
  }, [handleClose]);

  const handleOpen = () => {
    setOpen(true);
    blockScroll();
    props.openCallback && props.openCallback();
  };

  useOnClickOutside(ref, handleClose);

  return (
    <>
      <props.ButtonComponent onClick={handleOpen} mode={props.mode} />
      {open &&
        ReactDOM.createPortal(
          <div className="overlay">
            <div className={`overlay__wrapper${props.mobileSheet ? ' overlay__wrapper--bottom' : ''}`} id="overlay">
              <div className={`popup${props.mobileSheet ? ' popup--bottom' : ''}`} ref={ref}>
                <props.WindowComponent
                  onClose={handleClose}
                  sideOptions={props.sideOptions}
                  data={props.data}
                  {...props}
                />
              </div>
            </div>
          </div>,
          document.getElementById(MODAL_ID),
        )}
    </>
  );
}

ModalWindow.propTypes = {
  ButtonComponent: PropTypes.elementType.isRequired,
  WindowComponent: PropTypes.elementType.isRequired,
  mode: PropTypes.string,
  data: PropTypes.object,
};

export default ModalWindow;
